import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export var defaultConfig = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'newbuilding-genplan-mvk',
  pathApi: '/v1/get-similar-offers/',
  requestType: 'json',
  responseType: 'json'
};
export function createGetSimilarOffersModel(parameters) {
  return _objectSpread(_objectSpread({}, defaultConfig), {}, {
    parameters: parameters
  });
}
export function fetchGetSimilarOffers(_x) {
  return _fetchGetSimilarOffers.apply(this, arguments);
}
function _fetchGetSimilarOffers() {
  _fetchGetSimilarOffers = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var httpApi, config, mappers, parameters, _yield$httpApi$fetch, statusCode, response, headers;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          httpApi = _ref.httpApi, config = _ref.config, mappers = _ref.mappers, parameters = _ref.parameters;
          _context.next = 3;
          return httpApi.fetch(createGetSimilarOffersModel(parameters), config);
        case 3:
          _yield$httpApi$fetch = _context.sent;
          statusCode = _yield$httpApi$fetch.statusCode;
          response = _yield$httpApi$fetch.response;
          headers = _yield$httpApi$fetch.headers;
          if (!(mappers && statusCode in mappers)) {
            _context.next = 12;
            break;
          }
          if (!(statusCode === 200)) {
            _context.next = 10;
            break;
          }
          return _context.abrupt("return", mappers[200](response));
        case 10:
          if (!(statusCode === 400)) {
            _context.next = 12;
            break;
          }
          return _context.abrupt("return", mappers[400](response));
        case 12:
          return _context.abrupt("return", {
            statusCode: statusCode,
            response: response,
            headers: headers
          });
        case 13:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _fetchGetSimilarOffers.apply(this, arguments);
}